var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 149.5 263.3",
    style: {
      enableBackground: "new 0 0 149.5 263.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4893CF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000129909912622374300410000008113271331178049446_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75,51.8L75,51.8L75,51.8v177l0,0l0,0c-23.8,0-43-19.3-43-43v-91C32,71.1,51.3,51.8,75,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.5,51.8L89.5,51.8c23.8,0,43,19.3,43,43v39l0,0h-43l0,0V51.8C89.5,51.8,89.5,51.8,89.5,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111,151.3L111,151.3c11.9,0,21.5,9.6,21.5,21.5l0,0c0,11.9-9.6,21.5-21.5,21.5l0,0 c-11.9,0-21.5-9.6-21.5-21.5l0,0C89.5,160.9,99.1,151.3,111,151.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFina);
export default __webpack_public_path__ + "static/media/fina.1c2bbb2ad3cb027bf76db80a2a9386ef.svg";
export { ForwardRef as ReactComponent };